import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { finalConsentSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const FinalConsentScreenA: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.goToStep('email');
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/final-consent-scene-a.png`}
      title={'...You ready?'}
      choices={finalConsentSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
